const PRESELECT_MEDIA_COUNT = 5;
const MEDIA_SELECTION_LIMIT = 15;

export { PRESELECT_MEDIA_COUNT, MEDIA_SELECTION_LIMIT };
